import { useEffect } from "react";
import { FiUser } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import UserMenuDrawer from "../ui/UserMenuDrawer";
import "../../styles/UserMenuButton.css";

export default function UserMenuButton({
  chatId = "",
  open,
  onToggle,
  onClose,
  onOpenChat,
  onNewChat,
}) {
  const { t } = useTranslation("common");

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <div className="userMenuWrap">
      <button
        className="iconBtn"
        aria-label={t("user.button")}
        title={t("user.button")}
        onClick={(e) => {
          e.stopPropagation();
          onToggle?.();
        }}
      >
        <FiUser className="iconReact" />
      </button>

      <UserMenuDrawer
        open={open}
        onClose={onClose}
        onOpenChat={onOpenChat}
        onNewChat={onNewChat}
        chatId={chatId}
      />
    </div>
  );
}